<template>
  <div id="contenedor-contratos-configuracion-etiquetas">
    <v-container
      fluid>
      <v-card
        flat>
        <v-card-text>
          <listado-etiquetas
            modulo="contratos">
          </listado-etiquetas>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import ListadoEtiquetas from '@/components/administracion/configuracion/plantillas/etiquetas/listado/Desktop.vue';

export default {
  name: 'ContratosConfiguracionEtiquetas',
  data() {
    return {};
  },
  components: { ListadoEtiquetas },
};
</script>

<style lang="scss">

</style>
